module.exports = __webpack_public_path__ + "img/google play logo_new_transparent.165b4e79.svg";